module.exports = __webpack_public_path__ + "img/52002766_L.e2856d6b.png";